// Glass image lightbox (GlassLightbox). Prefix: alb-. Injected locally by the
// component. Matches the design's spv-lightbox overlay.
export const glassLightboxStyles = `
  .alb-root {
    position: fixed; inset: 0; z-index: var(--z-modal, 100);
    display: flex; align-items: center; justify-content: center;
    padding: 40px; cursor: zoom-out;
    background: rgba(15,72,89,0.5);
    -webkit-backdrop-filter: blur(10px) saturate(1.4); backdrop-filter: blur(10px) saturate(1.4);
  }
  /* The zoom stage. overflow: hidden clips the magnified image to the stage instead of letting it
     spill across the whole overlay and under the controls. touch-action: none is REQUIRED for
     pointer-based pan/pinch — without it the browser claims the gesture for page scrolling and the
     pointermove events stop arriving mid-drag. */
  .alb-stage {
    max-width: 92vw; max-height: 88vh;
    overflow: hidden;
    border-radius: var(--rad-catchup-large);
    box-shadow: 0 30px 80px -30px rgba(0,0,0,0.6);
    cursor: zoom-in;
    touch-action: none;
    display: flex; align-items: center; justify-content: center;
  }
  .alb-stage--zoomed { cursor: grab; }
  .alb-stage--zoomed:active { cursor: grabbing; }
  .alb-root img {
    max-width: 92vw; max-height: 88vh;
    display: block;
    /* transform-origin is the CENTRE because the pan offsets are computed from the stage centre. */
    transform-origin: center center;
    user-select: none; -webkit-user-select: none;
  }
  .alb-tools {
    position: absolute; bottom: 24px; left: 50%; transform: translateX(-50%);
    display: flex; align-items: stretch; gap: 4px; padding: 4px;
    border-radius: 99px;
    background: rgba(15,72,89,0.55);
    -webkit-backdrop-filter: blur(8px); backdrop-filter: blur(8px);
  }
  .alb-tool {
    min-width: 38px; height: 34px; padding: 0 12px;
    border: none; border-radius: 99px; cursor: pointer;
    /* fs-ok: lightbox chrome over a dark scrim, not activity content. */
    font-size: 15px; font-weight: 700; color: #fff;
    background: rgba(255,255,255,0.14);
    font-variant-numeric: tabular-nums;
  }
  .alb-tool:hover:not(:disabled) { background: rgba(255,255,255,0.28); }
  .alb-tool:disabled { opacity: 0.45; cursor: default; }
  .alb-tool--value { min-width: 62px; }
  .alb-hint {
    position: absolute; bottom: 66px; left: 50%; transform: translateX(-50%);
    margin: 0; text-align: center; max-width: 80vw;
    /* fs-ok: lightbox chrome over a dark scrim, not activity content. */
    font-size: 12px; font-weight: 600; color: rgba(255,255,255,0.75);
    pointer-events: none;
  }
  .alb-close {
    position: absolute; top: 20px; right: 24px;
    width: 42px; height: 42px; border-radius: 50%; border: none; cursor: pointer;
    /* fs-ok: lightbox close-button glyph over a dark scrim, not activity content. */
    font-size: 16px; font-weight: 700; color: #fff;
    background: rgba(255,255,255,0.18);
    -webkit-backdrop-filter: blur(8px); backdrop-filter: blur(8px);
  }
  .alb-close:hover { background: rgba(255,255,255,0.3); }
`;
